export class TopUpDiscriminationModel {
	public topupNewPCI: boolean;
	public topupNewPCIMsisdnPattern: string;
	public smartPayMSIDNPattern: string;
}
